module.exports = __webpack_public_path__ + "static/media/compound1.69af53a9.jpg";